import h from 'virtual-dom/h'
import { settings } from '../../../settings/settings-util'
import { canonicalizeUrl, subdomainOf } from '../../../util/url'

let _settings = settings;

export default class StepOutIcon {
    constructor(passedSettings) {
        if (passedSettings) {
            _settings = passedSettings;
        }
    }

    static getDefaultSettings() {
        return settings;
    }

    getReducer() {
        return state => state;
    }

    initialize() { }

    /**
     * Return whether (bool) to handle URL based on domain
     * @param {string} url URL to test for externality 
     * @return {boolean} Whether to handle the URL 
     */
    doesHandle(url) {
        if (!_settings.stepOutIcon) {
            return false;
        }

        const { ivaDomains, ivaSubdomains } = _settings.stepOutIcon;
        const { hostname } = canonicalizeUrl(url);

        if(hostname === window.location.hostname){
            return  false;
        }

        const sub = ivaDomains.map(d => subdomainOf(hostname, d)).find(s => s);

        // No matching IVA domain found
        if (sub == null) {
            return true;
        }
        // Wild - all subdomains are internal
        if (ivaSubdomains.includes('*')) {
            return false;
        }
        // It's on the list
        if (ivaSubdomains.includes(sub)) {
            return false;
        }

        return true;
    }

    renderIcon(url) {
        if (!this.doesHandle(url)) {
            return;
        }

        const className = _settings.classNames.stepOutIcon;
        this.injectSvg();
        return h('div', { className });
    }

    // TODO: Refactor - appending stuff post-render is not great
    injectSvg() {
        let x = 0;
        const intervalId = setInterval(() => {
            let stepOutDivs = [... document.getElementsByClassName(_settings.classNames.stepOutIcon)];
            stepOutDivs.forEach(div => div.innerHTML = _settings.stepOutIcon.iconSvg);

            if (++x === 10) {
                window.clearInterval(intervalId);
            }
        }, 100);
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/renderer-step-out-icon/src/renderer-step-out-icon.js